import { render, staticRenderFns } from "./inviteOpenUser.vue?vue&type=template&id=31dc118a&scoped=true"
import script from "./inviteOpenUser.vue?vue&type=script&lang=js"
export * from "./inviteOpenUser.vue?vue&type=script&lang=js"
import style0 from "./inviteOpenUser.vue?vue&type=style&index=0&id=31dc118a&prod&lang=scss&scoped=true"
import style1 from "./inviteOpenUser.vue?vue&type=style&index=1&id=31dc118a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc118a",
  null
  
)

export default component.exports